import { useSelector } from "react-redux";
import PlantDetails from "./plantDetails";
import { useEffect, useState } from "react";
import { AppState } from "../../../../common/store/combinedReducer";
import DeviceDetails from "./deviceDetails";
import "./css/sectionPanel.scss";
import { getNodeTypeIndex } from "./constants/nodeTypeOrder";
import noVmIcon from "../../../../common/assets/noVmIcon.png";

const buildFilterLabel = (filters: string[]): string | null => {
  if (!filters || filters.length === 0) return null;
  if (filters.length === 1) return `Filtered by ${filters[0]}`;
  if (filters.length === 2)
    return `Filtered by ${filters[0]} and ${filters[1]}`;
  return `Filtered by ${filters[0]}, ${filters[1]} and ${filters.length - 2} more Node Type${filters.length - 2 > 1 ? "s" : ""}`;
};

const SectionPanel = (props: any) => {
  const NODE_KEY = "Node Type";
  const selectedCluster = useSelector(
    (state: AppState) => state.reducer.selectedCluster,
  );

  const restartDisabled = props.disableRestart ?? props.disabled;
  const shutDownClickedProp = props.disableShutDown ?? props.shutDownClicked;

  useEffect(() => {
    props.vmDetails?.forEach((vm: any) => {
      vm.vmDetails?.sort((a: any, b: any) => {
        const aType = a.vmMetadata?.find((m: any) => m.key === NODE_KEY)?.value;
        const bType = b.vmMetadata?.find((m: any) => m.key === NODE_KEY)?.value;
        return getNodeTypeIndex(aType) - getNodeTypeIndex(bType);
      });
    });
  }, [props.vmDetails]);

  const hasVisibleClusters = props.vmDetails.some((vm: any) =>
    selectedCluster?.some((cluster: any) => cluster === vm.clusterName),
  );

  return (
    <div className="section-panel">
      {props.activeNodeFilter?.length > 0 && !hasVisibleClusters ? (
        <div className="no-data-available">
          <img className="icon-restore" src={noVmIcon} alt="No data" />
          <span className="no-detail-text">NO DATA TO DISPLAY</span>
          <span className="no-detail-text">
            Please change the applied filter
          </span>
        </div>
      ) : (
        props.vmDetails.map((vm: any, index: number) => {
          if (
            selectedCluster?.some((cluster: any) => cluster === vm.clusterName)
          ) {
            return (
              <div key={`section-${vm.clusterName}-${index}`} className="section-content">
                <div className="section-header-row">
                  <h2
                    className="section-header"
                    id={`cluster-${vm.clusterName}`}
                  >
                    {!props.isHonAcaTenant ? vm.clusterName : null}
                  </h2>
                  {buildFilterLabel(props.activeNodeFilter) && (
                    <span className="section-filter-label">
                      {buildFilterLabel(props.activeNodeFilter)}
                    </span>
                  )}
                </div>
                {props.activeNodeFilter?.length > 0 &&
                (!vm.vmDetails || vm.vmDetails.length === 0) ? (
                  <div className="no-vm-node-message">
                    No VM available with selected node type
                  </div>
                ) : (
                  <DeviceDetails
                    plantName={props.plantName}
                    orgId={props.orgId}
                    orgData={vm}
                    plant={props.plant}
                    vmDetails={vm.vmDetails || []}
                    clearAll={props.clearAll}
                    setClearAll={props.setClearAll}
                    handleClearAll={props.handleClearAll}
                    disabled={restartDisabled}
                    setRestart={props.setRestart}
                    shutDownClicked={shutDownClickedProp}
                    setShutDown={props.setShutDown}
                    setCreateSnapshotDisable={props.setCreateSnapshotDisable}
                    setHeader={props.setHeader}
                    setContent={props.setContent}
                    setCloseConfirmModal={props.setCloseConfirmModal}
                    setPoweredVm={props.setPoweredVm}
                    setClicked={props.setClicked}
                    clicked={props.clicked}
                    setOpenVm={props.setOpenVm}
                    openVm={props.openVm}
                    showIso={props.showIso}
                    setShowIso={props.setShowIso}
                    selectedIso={props.selectedIso}
                    setSnapShotShow={props.setSnapShotShow}
                  />
                )}
              </div>
            );
          }
        })
      )}
    </div>
  );
};
export default SectionPanel;
